var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-dark my-2",on:{"click":_vm.handleBackClick}},[_c('span',{staticClass:"fa fa-caret-left"}),_vm._v(" "),_c('span',{staticClass:"fa fa-caret-left"})])}
var staticRenderFns = []

export { render, staticRenderFns }